import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Row, Col, Tooltip } from "antd";
import RecurringIcon from "../../../../../../../assets/icons/recurring.svg";
import {
  LabelDataHeading,
  ValueDataHeading,
  UnderlyingContent,
  ContentDivider,
} from "../../../style";
import { ModelDataHeading } from "../style";
import { isGeminiUser } from "../../../../../../../utils/sessionUtil";
import { addressFormat } from "../../../utils";
import { removeNtee } from "../../../../../../../CommonComponents/CharitySearch/utils";
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";

export default function RecentCharityCard({
  data,
  grantHistoryHandler,
  pendingCharityHandler,
  scheduleHistoryHandler,
  activityBlocked = "",
}) {
  return (
    <div>
      <Row>
        <Col span={22}>
          <ModelDataHeading>{data.charityName}</ModelDataHeading>
        </Col>
        <Col span={2}>
          {data.isRecurring && (
            <div data-test='recent-charity-section' onClick={() => scheduleHistoryHandler(data)}>
              <img src={RecurringIcon} alt="Recurring-grant" />
            </div>
          )}
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHeading>EIN</LabelDataHeading>
          <UnderlyingContent data-test='recent-charity-ein' onClick={() => grantHistoryHandler(data)}>
            {data.ein}
          </UnderlyingContent>
        </Col>
        <Col span={12}>
          <LabelDataHeading>Address</LabelDataHeading>
          <Tooltip
            placement="bottom"
            title={addressFormat({ ...data, zipCode: data.zip })}
            trigger="click"
          >
            <UnderlyingContent>{data.location}</UnderlyingContent>
          </Tooltip>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHeading>Last grant issued</LabelDataHeading>
          <ValueDataHeading>
            {moment(data.lastGrantDate).format("L")}
          </ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHeading>Interest Area</LabelDataHeading>
          <ValueDataHeading>
            {data.interestArea ? removeNtee(data.interestArea) : ""}
          </ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      {isGeminiUser() && (
        <>
          <Row className="geminiColor">
            <Col span={12}>
              <LabelDataHeading>Grantee Org. Status</LabelDataHeading>
              <ValueDataHeading>{data.granteeOrgStatus}</ValueDataHeading>
            </Col>
          </Row>
          <ContentDivider />
        </>
      )}

      <Row>
        <Col span={8}>
          <CapsuleButton
            data-test="recent-charity-capsule"
            onClick={() => pendingCharityHandler(data)}
            disabled={!!activityBlocked}
            title={activityBlocked}
            text="Select"
            whiteBackground
            iconType="arrowRight"
            alt = "charity select"
          />
        </Col>
      </Row>
    </div>
  );
}

RecentCharityCard.propTypes = {
  activityBlocked: PropTypes.bool,
  component: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      addressLine3: PropTypes.string,
      charityId: PropTypes.number,
      charityName: PropTypes.string,
      city: PropTypes.string,
      country: PropTypes.string,
      ein: PropTypes.string,
      grantId: PropTypes.number,
      granteeOrgein: PropTypes.string,
      idx: PropTypes.any,
      interestArea: PropTypes.string,
      isPending: PropTypes.bool,
      isRecurring: PropTypes.bool,
      lastGrantDate: PropTypes.number,
      location: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
    })
  ),
  grantHistoryHandler: PropTypes.func,
  index: PropTypes.number,
  pendingCharityHandler: PropTypes.func,
  scheduleHistoryHandler: PropTypes.func,
};
